<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <div class="bottomTab" v-if="showBottomTab" style="height: 3.75rem"></div>
  </div>
</template>
<script>
import * as api from './api/api'
import * as common from './api/common'

export default {
  data () {
    return {
      showBottomTab: true
    }
  },
  watch: {
    '$route' (to) {
      // 检查当前路由是否属于主页面
      if (['order', 'message', 'my'].includes(to.name)) {
        this.showBottomTab = true
      } else {
        this.showBottomTab = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const realHeight = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight
      this.setMetaHeight(realHeight)
      // 禁止长按复制等
      document.addEventListener('contextmenu', function (event) {
        event.preventDefault()
      })
    })
  },
  methods: {
    // 设置meta高度 解决安卓浏览器软键盘弹起，占用窗口的面积把元素顶起的问题
    setMetaHeight (height) {
      document.head.querySelector("meta[name='viewport']").setAttribute('id', 'viewportMeta')
      const metaEl = document.querySelector('#viewportMeta')
      const content = 'height=' + height + ',width=device-width,initial-scale=1.0,user-scalable=no'
      metaEl.setAttribute('name', 'viewport')
      metaEl.setAttribute('content', content)
      this.$forceUpdate()
    },

    getConfig (val) {
      const para = {
        access_token: val || localStorage.getItem('accessToken')
      }
      api
        .axiosRequest(common.baseUrlApiConfig + api.urlList.getConfig, para)
        .then((res) => {
          if (res && res.code === common.resCode.OK) {
            if (res) res.base_span = res.base_span || 30
            if (res) {
              res.startEndTimeExplain = res.begin_time + '-' + res.end_time
            }
            api.setConfig(JSON.stringify(res))
            this.$store.commit('CONFIGINFO', JSON.stringify(res))
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    }
  },
  beforeDestroy () {
    localStorage.removeItem(common.keyConfigInfo)
    api.setCookie(common.keyConfigInfo, '', -1)
  },
  beforeCreate () {
    const origin = window.location.origin
    if (!/10\.1\.7.+|127\.0\.0\.1|192\.168\.*|localhost/.test(origin) && location.protocol === 'http:') {
      window.location.href = 'https://' + window.location.host
    }
  }
}
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  // 禁止长按复制
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge */
  user-select: none;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
span,
div,
ul,
li,
p {
  cursor: default;
}
</style>
